import { defineStore } from 'pinia';

// 获取列表数据
const useFlowStore = defineStore('flow', {
  state: (): any => ({
    // 条件审批支持的条件字段
    conditionFields: [],
    // 条件字段和选择类型映射 DESIGN_BRAND -> BRAND
    conditionFieldAndSelectTypeMap: {},
  }),

  getters: {},

  actions: {
    setConditionFields(data: Array<Recordable>) {
      this.conditionFields = data || [];
      this.conditionFields.forEach((item: any) => {
        this.conditionFieldAndSelectTypeMap[item.field] = item.valueSelectType;
      });
    },
  },
});

export default useFlowStore;
